// store/mapStore.js
import { defineStore } from 'pinia';

export const useMapStore = defineStore('mapStore', () => {
  let map
  let layers = [];

  function setMap(mapInstance) {
    map = mapInstance;
  }

  function addLayer(layer) {
    if (map) {
      layer.addTo(map);
      layers.push(layer);
    }
  }

  function removeLayer(layer) {
    if (map) {
      map.removeLayer(layer);
      layers = layers.filter(l => l !== layer);
    }
  }

  function fitBounds(tl, br)
  {
    console.log(`fitBounds: ${JSON.stringify(tl)} , ${JSON.stringify(br)}`)
    map.fitBounds([tl, br])
  }

  return { map, setMap, addLayer, removeLayer, fitBounds };
});